import { render, staticRenderFns } from "./TematismBox.vue?vue&type=template&id=8d9dd756"
import script from "./TematismBox.vue?vue&type=script&lang=js"
export * from "./TematismBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports